/** The "Diagnose" tab — a thin EDL adapter over the shared AI chat panel
 *  (features/ai-diag). All chat/thread/polling behavior lives there; this
 *  file only says how to start an EDL diagnosis and how to recognize this
 *  delivery's tasks in the bgtasks listing. */
import { useMemo } from 'react';

import * as edlApi from '@/api/eventDeliveryLogs';
import { AiDiagChat } from '@/features/ai-diag/AiDiagChat';
import type { AiDiagAdapter } from '@/features/ai-diag/types';

export function AiDiagnosePanel({ edlId, logId }: { edlId: string; logId?: string }) {
  const adapter: AiDiagAdapter = useMemo(
    () => ({
      launchContext: edlApi.diagnoseLaunchContext,
      start: (body) => edlApi.startDiagnose(edlId, body),
      taskType: 'edl_diagnose',
      subjectNoun: 'delivery',
      subjectTitle: `Delivery ${logId ?? edlId}`,
      questionPlaceholder: 'e.g. "The guest says they received this email twice — why?"',
      // The task label carries the log_id — narrows the listing server-side;
      // matchesSubject pins it to this exact row (redelivery chains share
      // the log_id).
      labelContains: logId,
      matchesSubject: (params) =>
        (params as { event_delivery_id?: string } | null)?.event_delivery_id === edlId,
    }),
    [edlId, logId],
  );
  return (
    <AiDiagChat
      adapter={adapter}
      subjectNote={
        "The AI sees this delivery's archive, backend logs, templates and " +
        'their change history — nothing else.'
      }
    />
  );
}
